import type { ShellHost } from "./ports.ts";

/**
 * The realm's host cell, kept apart from shellHost.ts for code that works
 * with or without a host: an in-app link also renders on public pages, which
 * install none, and there it falls back to a plain link. Importing this
 * module is not a host read (tests/oss/shellHostInstall.test.ts lets a client
 * tree without a binding load it), so nothing here may assume a host is
 * installed, and it imports no values.
 */
let installed: ShellHost | null = null;

/** The installed host, or null before `installShellHost` (a public page that renders none). */
export function installedShellHost(): ShellHost | null {
  return installed;
}

/** Sets the cell. Only `installShellHost` calls this (guarded by tests/oss/shellHostInstall.test.ts). */
export function setInstalledShellHost(host: ShellHost): void {
  installed = host;
}
